module.exports = __webpack_public_path__ + "img/icon_school_logo.b7970a0f.png";